import React from "react";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import useStyles from "./styles";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 280,
    },
  },
};

export default function MultiSelectSubCategory({
  selectedIds,
  List,
  setFieldValue,
  name,
  heading,
  setSubCategoryId,
  categories,
}) {
  const classes = useStyles();
  const subcategory = List?.map((result) => result.map((result) => result));
  const subcategories = subcategory?.flat();
  const key = "id";
  const subcategoryList = [
    ...new Map(subcategories.map((item) => [item[key], item])).values(),
  ];
  // console.log("subcategoryList", subcategoryList);

  const isAllSelected =
    subcategoryList.length > 0 && selectedIds.length === subcategoryList.length;

  const handleChange = (e) => {
    const value = e.target.value;

    if (value[value.length - 1] === "all") {
      setFieldValue(
        name,
        selectedIds.length === subcategoryList.length
          ? []
          : subcategoryList.map((category) => category.id)
      );
      setSubCategoryId(subcategoryList.map((category) => category.id));
      return;
    }
    setFieldValue(name, value);
    setSubCategoryId(value);
  };

  return (
    <div style={{ display: "inline-block", marginTop: "4%" }}>
      <FormControl className={classes.formControl} variant="outlined">
        <InputLabel id="demo-mutiple-checkbox-label" className="form-label">
          {heading}
          <span className="required">&#42;</span>
        </InputLabel>
        <Select
          labelId="demo-mutiple-checkbox-label"
          id="demo-mutiple-checkbox"
          multiple
          value={selectedIds}
          onChange={handleChange}
          input={<Input />}
          renderValue={(selected) =>
            subcategoryList
              ?.filter((subcategory) => selected.includes(subcategory.id))
              .map((subcategory) => subcategory.name)
              .join(", ")
          }
          MenuProps={MenuProps}
        >
          {subcategoryList.length > 1 && (
            <MenuItem
              value="all"
              classes={{
                root: isAllSelected ? classes.selectedAll : "",
              }}
            >
              <ListItemIcon>
                <Checkbox
                  classes={{ indeterminate: classes.indeterminateColor }}
                  checked={isAllSelected}
                  indeterminate={
                    selectedIds.length > 0 &&
                    selectedIds.length < subcategoryList.length
                  }
                />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.selectAllText }}
                primary="Select All"
              />
            </MenuItem>
          )}

          {subcategoryList?.map((category) => (
            <MenuItem key={category._id} value={category.id}>
              <Checkbox checked={selectedIds.indexOf(category.id) > -1} />
              <ListItemText primary={category.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
